export default __webpack_public_path__ + "static/media/user-data-bg.daae93d2.jpg";